import(/* webpackMode: "eager" */ "/app/app/(default)/cart/[[...slug]]/page.jsx");
